export default [
  {
    tireLineName: 'Vanguard STR II',
    tires: [
      {
        size: 'ST175/80R13 91/87L C',
        speedRating: 'L',
        loadIndex: '91/87',
        plyRating: 'C/6',
        singleLoad: '1360',
        dualLoad: '1200',
        outsideDiameter: '24.01'
      },
      {
        size: 'ST235/80R16 123/119L E',
        speedRating: 'L',
        loadIndex: '123/119',
        plyRating: 'E/10',
        singleLoad: '3420',
        dualLoad: '3000',
        outsideDiameter: '30.78'
      },
      {
        size: 'ST205/75R14 100/96L C',
        speedRating: 'L',
        loadIndex: '100/96',
        plyRating: 'C/6',
        singleLoad: '1760',
        dualLoad: '1565',
        outsideDiameter: '26.14'
      },
      {
        size: 'ST215/75R14 102/98L C',
        speedRating: 'L',
        loadIndex: '102/98',
        plyRating: 'C/6',
        singleLoad: '1870',
        dualLoad: '1655',
        outsideDiameter: '26.69'
      },
      {
        size: 'ST205/75R15 101/97L C',
        speedRating: 'L',
        loadIndex: '101/97',
        plyRating: 'C/6',
        singleLoad: '1820',
        dualLoad: '1610',
        outsideDiameter: '27.12'
      },
      {
        size: 'ST205/75R15 107/102L D',
        speedRating: 'L',
        loadIndex: '107/102',
        plyRating: 'D/8',
        singleLoad: '2150',
        dualLoad: '1875',
        outsideDiameter: '27.12'
      },
      {
        size: 'ST225/75R15 113/108L D',
        speedRating: 'L',
        loadIndex: '113/108',
        plyRating: 'D/8',
        singleLoad: '2540',
        dualLoad: '2205',
        outsideDiameter: '28.3'
      },
      {
        size: 'ST225/75R15 117/112L E',
        speedRating: 'L',
        loadIndex: '117/112',
        plyRating: 'E/10',
        singleLoad: '2830',
        dualLoad: '2470',
        outsideDiameter: '28.3'
      }
    ]
  },
  {
    tireLineName: 'Trailer King II',
    tires: [
      {
        size: 'ST175/80R13 91/87L C',
        speedRating: 'L',
        loadIndex: '91/87',
        plyRating: 'C/6',
        singleLoad: '1360',
        dualLoad: '1200',
        outsideDiameter: '24'
      },
      {
        size: 'ST185/80R13 94/89L C',
        speedRating: 'L',
        loadIndex: '91/89',
        plyRating: 'C/6',
        singleLoad: '1480',
        dualLoad: '1280',
        outsideDiameter: '24.6'
      },
      {
        size: 'ST235/85R16 125/122L E',
        speedRating: 'L',
        loadIndex: '125/122',
        plyRating: 'E/10',
        singleLoad: '3640',
        dualLoad: '3305',
        outsideDiameter: '31.7'
      },
      {
        size: 'ST235/80R16 124/120L E',
        speedRating: 'L',
        loadIndex: '124/120',
        plyRating: 'E/10',
        singleLoad: '3520',
        dualLoad: '3080',
        outsideDiameter: '30.8'
      },
      {
        size: 'ST205/75R14 100/96L C',
        speedRating: 'L',
        loadIndex: '100/96',
        plyRating: 'C/6',
        singleLoad: '1760',
        dualLoad: '1570',
        outsideDiameter: '27.1'
      },
      {
        size: 'ST215/75R14 102/98L C',
        speedRating: 'L',
        loadIndex: '102/98',
        plyRating: 'C/6',
        singleLoad: '1870',
        dualLoad: '1650',
        outsideDiameter: '26.7'
      },
      {
        size: 'ST205/75R15 101/97L C',
        speedRating: 'L',
        loadIndex: '101/97',
        plyRating: 'C/6',
        singleLoad: '1820',
        dualLoad: '1610',
        outsideDiameter: '27.1'
      },
      {
        size: 'ST205/75R15 107/102L D',
        speedRating: 'L',
        loadIndex: '107/102',
        plyRating: 'D/8',
        singleLoad: '2150',
        dualLoad: '1870',
        outsideDiameter: '27.1'
      },
      {
        size: 'ST225/75R15 113/108L D',
        speedRating: 'L',
        loadIndex: '113/108',
        plyRating: 'D/8',
        singleLoad: '2540',
        dualLoad: '2200',
        outsideDiameter: '28.3'
      },
      {
        size: 'ST225/75R15 117/112L E',
        speedRating: 'L',
        loadIndex: '117/112',
        plyRating: 'E/10',
        singleLoad: '2830',
        dualLoad: '2470',
        outsideDiameter: '28.3'
      }
    ]
  },
  {
    tireLineName: 'Goodyear Endurance ST',
    tires: [
      {
        size: 'ST225/75R15 117/112N E',
        speedRating: 'N',
        loadIndex: '117/112',
        plyRating: 'E/10',
        singleLoad: '2833',
        dualLoad: '2470',
        outsideDiameter: '28.29'
      },
      {
        size: 'ST235/80R16 123/119N E',
        speedRating: 'N',
        loadIndex: '123/119',
        plyRating: 'E/10',
        singleLoad: '3417',
        dualLoad: '3000',
        outsideDiameter: '30.8'
      },
      {
        size: 'ST235/85E16 125/122N E',
        speedRating: 'N',
        loadIndex: '125/122',
        plyRating: 'E/10',
        singleLoad: '3638',
        dualLoad: '3305',
        outsideDiameter: '31.73'
      },
      {
        size: 'ST205/75R15 107/102N D',
        speedRating: 'N',
        loadIndex: '107/102',
        plyRating: 'D/8',
        singleLoad: '2149',
        dualLoad: '1875',
        outsideDiameter: '27.11'
      },
      {
        size: 'ST255/85R16 129/125N E',
        speedRating: 'N',
        loadIndex: '129/125',
        plyRating: 'E/10',
        singleLoad: '4079',
        dualLoad: '3638',
        outsideDiameter: '33.07'
      },
      {
        size: 'ST205/75R14 105/101N D',
        speedRating: 'N',
        loadIndex: '105/101',
        plyRating: 'D/8',
        singleLoad: '2039',
        dualLoad: '1819',
        outsideDiameter: '26.11'
      },
      {
        size: 'ST215/75R14 108/103N D',
        speedRating: 'N',
        loadIndex: '108/103',
        plyRating: 'D/8',
        singleLoad: '2205',
        dualLoad: '1929',
        outsideDiameter: '26.7'
      }
    ]
  },
  {
    tireLineName: 'Sailun S637T',
    tires: [
      {
        size: 'ST235/85R16 132/127L G',
        speedRating: 'L',
        loadIndex: '132/127',
        plyRating: 'G/14',
        singleLoad: '4409',
        dualLoad: '3858',
        outsideDiameter: '31.73'
      },
      {
        size: 'ST235/80R16 129/125L G',
        speedRating: 'L',
        loadIndex: '129/125',
        plyRating: 'G/14',
        singleLoad: '4079',
        dualLoad: '3638',
        outsideDiameter: '30.8'
      }
    ]
  },
  {
    tireLineName: 'Trailer King RST',
    tires: [
      {
        size: 'ST175/80R13 91/87M C',
        speedRating: 'M',
        loadIndex: '91/87',
        plyRating: 'C/6',
        singleLoad: '1360',
        dualLoad: '1200',
        outsideDiameter: '24.02'
      },
      {
        size: 'ST235/80R16 124/120M E',
        speedRating: 'M',
        loadIndex: '124/120',
        plyRating: 'E/10',
        singleLoad: '3420',
        dualLoad: '3000',
        outsideDiameter: '30.8'
      },
      {
        size: 'ST205/75R14 100/96M C',
        speedRating: 'M',
        loadIndex: '100/96',
        plyRating: 'C/6',
        singleLoad: '1760',
        dualLoad: '1570',
        outsideDiameter: '26.11'
      },
      {
        size: 'ST215/75R14 102/98M C',
        speedRating: 'M',
        loadIndex: '102/98',
        plyRating: 'C/6',
        singleLoad: '1870',
        dualLoad: '1650',
        outsideDiameter: '26.7'
      },
      {
        size: 'ST205/75R15 101/97M C',
        speedRating: 'M',
        loadIndex: '101/97',
        plyRating: 'C/6',
        singleLoad: '1820',
        dualLoad: '1610',
        outsideDiameter: '27.11'
      },
      {
        size: 'ST205/75R15 107/102M D',
        speedRating: 'M',
        loadIndex: '107/102',
        plyRating: 'D/8',
        singleLoad: '2150',
        dualLoad: '1870',
        outsideDiameter: '27.11'
      },
      {
        size: 'ST225/75R15 113/108M D',
        speedRating: 'M',
        loadIndex: '113/108',
        plyRating: 'D/8',
        singleLoad: '2540',
        dualLoad: '2200',
        outsideDiameter: '28.29'
      },
      {
        size: 'ST225/75R15 117/112M E',
        speedRating: 'M',
        loadIndex: '117/112',
        plyRating: 'E/10',
        singleLoad: '2860',
        dualLoad: '2470',
        outsideDiameter: '28.29'
      }
    ]
  }
]
